import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateAttachmentCategoryPayload {
  name: string;
  status: number;
}

export interface UpdateAttachmentCategoryPaylod extends CreateAttachmentCategoryPayload {}

export const ATTACHMENT_CATEGORY_QUERY_KEY = ["attachment-category"] as const;
export const VIEW_ATTACHMENT_CATEGORY_QUERY_KEY = [
  "view-attachment-category",
] as const;

export const attachmentCategoryService = {
  createAttachmentCategory: async (
    payload: CreateAttachmentCategoryPayload,
  ) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/attachment-category", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showAttachmentCategory: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/attachment-category/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateAttachmentCategory: async (
    id: number,
    payload: UpdateAttachmentCategoryPaylod,
  ) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/attachment-category/${id}`,
        payload,
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/attachment-category/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  getAllAttachmentCategories: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-attachment-categories`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getAttachmentCategories: async () =>
    requestWithRefresh(() =>
      api
        .get("api/attachment-category", {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
